import { jsxs as I, jsx as o, Fragment as oe } from "react/jsx-runtime";
import { ButtonIcon as ae } from "./ButtonIcon.js";
import { g as ce } from "../chunks/generate-random-id.f7e64105.js";
import { m as de } from "../chunks/make-refs.cb0b9b76.js";
import { useEffect as x, forwardRef as le, useMemo as ie, useRef as ue, useState as k } from "react";
import { f as J, g as me, e as fe, b as we, a as he, d as ve, s as $, c as Ee } from "../chunks/common.403a14df.js";
const H = (d) => Array.from(
  d.querySelectorAll(J)
), ye = ({
  isOpen: d,
  onClose: p,
  onResize: E,
  ref: l
}) => {
  x(() => {
    E();
    const g = (s) => {
      var t;
      d && s.target instanceof Node && !((t = l.current) != null && t.contains(s.target)) && p();
    }, C = (s) => {
      d && s.key === "Escape" && (s.preventDefault(), p());
    }, w = (s) => {
      var L, m;
      if (s.key !== "Tab")
        return;
      const t = document.activeElement;
      if (t.closest("video, iframe") !== null)
        return;
      s.preventDefault();
      const n = l.current ? H(l.current) : [], h = n.indexOf(t);
      if (s.shiftKey) {
        const c = h > 0 ? h - 1 : n.length - 1;
        (L = n[c]) == null || L.focus();
      } else {
        const c = h < n.length - 1 ? h + 1 : 0;
        (m = n[c]) == null || m.focus();
      }
    }, i = (s) => {
      var u, n;
      const t = s.relatedTarget;
      t && !((u = l.current) != null && u.contains(t)) && ((n = H(l.current)[0]) == null || n.focus());
    };
    return window.addEventListener("resize", E), d && (window.addEventListener("mousedown", g), window.addEventListener("focusout", i), window.addEventListener("keydown", C), window.addEventListener("keydown", w)), () => {
      window.removeEventListener("resize", E), window.removeEventListener("mousedown", g), window.removeEventListener("focusout", i), window.removeEventListener("keydown", C), window.removeEventListener("keydown", w);
    };
  }, [d, l]);
};
let f = [];
const q = "nds-has-modal", Ie = le(
  ({
    bodyClassName: d,
    contentClassName: p,
    children: E,
    className: l,
    closeBtnA11yLabel: g,
    closeBtnA11yTitle: C,
    contentSlot: w,
    description: i,
    dismissClassName: s,
    fixedFooter: t,
    footerSlot: u,
    heading: n,
    headingElement: h = "h5",
    id: L,
    isMediaModal: m = !1,
    isOpen: c = !1,
    onBeforeClose: D,
    onClose: B,
    position: P = "center",
    size: Q = "medium",
    ...U
  }, X) => {
    const a = L || ie(() => ce(), []), { $el: r, dismissBtn: Y } = de(X, ["$el", "dismissBtn"]), R = ue(null), [Z, _] = k(!1), [F, A] = k(!1), [K, b] = k(c), [N, j] = k(c);
    x(() => (b(c), f = c ? [...new Set(f.concat(a))] : f.filter((e) => e !== a), () => {
      f = f.filter((e) => e !== a);
    }), [c]), ye({
      isOpen: F,
      ref: r,
      onClose: () => {
        f[f.length - 1] === a && b(!1);
      },
      onResize() {
        window.innerWidth >= 768 && R.current && r.current && _(Ee(R.current));
      }
    });
    const z = () => document.documentElement.classList.remove(q);
    x(() => {
      var e;
      if (K)
        document.documentElement.classList.add(q), j(!0);
      else {
        if (D && !D())
          return b(!0), z;
        document.documentElement.classList.remove(q), A(!1), (e = r.current) == null || e.addEventListener("transitionend", (y) => {
          var v, G;
          y.target === r.current && y.propertyName === "opacity" && (B == null || B(), (G = (v = r.current).close) == null || G.call(v), j(!1));
        });
      }
      return z;
    }, [K]);
    const O = () => {
      var e;
      return (e = r.current.querySelector(J)) == null ? void 0 : e.focus();
    }, S = (e) => {
      e.target === r.current && e.propertyName === "opacity" && (O(), r.current.removeEventListener(
        "transitionend",
        S
      ));
    };
    x(() => {
      var e, y;
      if (r.current && N)
        r.current.addEventListener("transitionend", S), O(), (y = (e = r.current).show) == null || y.call(e), A(!0);
      else if (!N) {
        const v = document.body.querySelector(
          `[data-controls="${a}"],[aria-controls="${a}"]`
        );
        v == null || v.focus();
      }
    }, [N]);
    const T = () => /* @__PURE__ */ o("div", { className: re, children: /* @__PURE__ */ o(
      ae,
      {
        ref: Y,
        icon: "24/symbol/close",
        size: "small",
        "aria-label": g,
        title: C,
        onClick: () => b(!1)
      }
    ) }), V = () => /* @__PURE__ */ o("footer", { className: se, ref: R, children: u }), W = () => /* @__PURE__ */ I(oe, { children: [
      (i || w) && /* @__PURE__ */ I("div", { className: te, children: [
        i && /* @__PURE__ */ o(
          "p",
          {
            id: `${a}-description`,
            className: $.description,
            children: i
          }
        ),
        w
      ] }),
      (!m || !t) && u && /* @__PURE__ */ o(V, {})
    ] }), M = i || w || u, ee = me({ className: l, fixedFooter: t, size: Q, position: P }), se = fe({ isColumnMode: Z }), te = we({ bodyClassName: d }), ne = he({ contentClassName: p }), re = ve({ dismissClassName: s });
    return N ? /* @__PURE__ */ I(
      "dialog",
      {
        "aria-describedby": i && `${a}-description`,
        "aria-labelledby": n && `${a}-heading`,
        "aria-modal": !0,
        className: ee,
        id: a,
        open: F,
        ref: r,
        tabIndex: -1,
        ...U,
        children: [
          m && /* @__PURE__ */ o(T, {}),
          E,
          n ? /* @__PURE__ */ I("header", { className: $.header, children: [
            /* @__PURE__ */ o(
              h,
              {
                id: `${a}-heading`,
                className: $.heading,
                children: n
              }
            ),
            !m && /* @__PURE__ */ o(T, {})
          ] }) : !m && /* @__PURE__ */ o("header", { className: $.header, children: /* @__PURE__ */ o(T, {}) }),
          M ? /* @__PURE__ */ o("div", { className: ne, children: W() }) : W(),
          m && t && u && /* @__PURE__ */ o(V, {})
        ]
      }
    ) : null;
  }
);
export {
  Ie as Modal
};
//# sourceMappingURL=Modal.js.map
